import { t } from '@moovly/i18n';
import { IconDelete } from '@moovly/ui';
import * as React from 'react';
import {
  Table,
  TableAction,
  TableBody,
  TableCol,
  TableHeadCol,
  TableHeader,
  TableRow,
} from '../../../components/Table';
import { transformFontFamily } from '../utils/font';

interface FontsTableProps {
  fonts: any[];
  onDelete: (fontId: string) => void;
}
const FontsTable: React.FC<FontsTableProps> = ({ fonts, onDelete }) => {
  const handleDelete = React.useCallback((familyId: string) => () => onDelete(familyId), [onDelete]);
  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeadCol>{t('fonts.table.font')}</TableHeadCol>
            <TableHeadCol>{t('fonts.table.type')}</TableHeadCol>
            <TableHeadCol>{t('fonts.table.actions')}</TableHeadCol>
          </TableRow>
        </TableHeader>
        <TableBody>
          {fonts.map((family) => {
            const { fontFamily, fontTypes } = transformFontFamily(family.name);
            return (
              <TableRow key={`font-${family.id}`}>
                <TableCol>{fontFamily}</TableCol>
                <TableCol>{fontTypes}</TableCol>
                {!family.public && (
                  <TableCol>
                    <TableAction
                      icon={IconDelete}
                      onClick={handleDelete(family.id)}
                      tooltip={t('fonts.table.remove')}
                    />
                  </TableCol>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
};
export default FontsTable;
